import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "locationTypeSelector",
    "addressFields",
    "coordinateFields",
    "mailingFieldContainer",
    "mailingCheckbox",
    "addressModal",
    "addressModalTitle",
    "addressContent",
    "addressNoResultsContent",
    "addressActions",
    "addressNoResultsActions",
    "addressResult",
    "addressSaveBtn",
    "validateAddressButton"
  ]

  connect() {
    this.address = null
    this.streetInput = null
    this.cityInput = null
    this.stateInput = null
    this.countryInput = null
    this.postalCodeInput = null
    this.statusInput = null

    if (this.hasMailingCheckboxTarget && this.mailingCheckboxTarget.checked) {
      this.mailingFieldContainerTarget.style.display = 'none'
    }

    if (this.hasLocationTypeSelectorTarget) {
      const selected = this.element.querySelector('input[name*="location_type"]:checked')
      if (selected) {
        const isAddress = selected.value === 'street_address'
        this.addressFieldsTarget.style.display = isAddress ? '' : 'none'
        this.coordinateFieldsTarget.style.display = isAddress ? 'none' : ''
        this.toggleValidateButton(isAddress)
      }
    }
  }

  toggleLocationType(event) {
    const isAddress = event.target.value === 'street_address'
    this.addressFieldsTarget.style.display = isAddress ? '' : 'none'
    this.coordinateFieldsTarget.style.display = isAddress ? 'none' : ''
    this.toggleValidateButton(isAddress)
  }

  toggleValidateButton(isAddress) {
    if (this.hasValidateAddressButtonTarget) {
      this.validateAddressButtonTarget.style.display = isAddress ? '' : 'none'
    }
  }

  toggleMailingFields(event) {
    this.mailingFieldContainerTarget.style.display = event.target.checked ? 'none' : ''
  }

  validateAddress(event) {
    const isMailing = event.currentTarget.id.includes('mailing')
    const prefix = isMailing ? 'location_mailing_' : 'location_'

    this.streetInput = document.getElementById(`${prefix}addr1`)
    this.cityInput = document.getElementById(`${prefix}city`)
    this.stateInput = document.getElementById(`${prefix}state_code`)
    this.countryInput = document.getElementById(`${prefix}country_code`)
    this.postalCodeInput = document.getElementById(`${prefix}postal_code`)
    this.statusInput = document.getElementById(`${prefix}validation_status`)

    const url = '/places/search/'
      + '?street=' + encodeURIComponent(this.streetInput.value)
      + '&city=' + encodeURIComponent(this.cityInput.value)
      + '&state=' + encodeURIComponent(this.stateInput.value)
      + '&country=' + encodeURIComponent(this.countryInput.value)
      + '&postal_code=' + encodeURIComponent(this.postalCodeInput.value)

    fetch(url)
      .then(res => res.json())
      .then(data => {
        this.address = data
        this.showAddress()
      })
  }

  showAddress() {
    const modal = this.addressModalTarget

    if (this.address.status === 'No Results') {
      this.statusInput.value = 'Not Validated'
      this.addressModalTitleTarget.textContent = 'No Results'
      this.addressContentTarget.style.display = 'none'
      this.addressNoResultsContentTarget.style.display = ''
      this.addressActionsTarget.style.display = 'none'
      this.addressNoResultsActionsTarget.style.display = ''
      modal.showModal()
    } else if (!this.address.partial_match) {
      // Exact match — copy directly, no modal needed
      this.copyAddress()
    } else {
      this.addressModalTitleTarget.textContent = 'Confirm Address'
      this.addressResultTarget.textContent = this.address.formatted_address
      this.addressContentTarget.style.display = ''
      this.addressNoResultsContentTarget.style.display = 'none'
      this.addressActionsTarget.style.display = ''
      this.addressNoResultsActionsTarget.style.display = 'none'
      modal.showModal()
    }
  }

  saveAddress() {
    this.copyAddress()
    this.addressModalTarget.close()
  }

  closeModal() {
    this.addressModalTarget.close()
  }

  copyAddress() {
    this.copyValue(this.streetInput, this.address.street)
    this.copyValue(this.cityInput, this.address.city)
    this.copyValue(this.stateInput, this.address.state)
    this.copyValue(this.countryInput, this.address.country)
    this.copyValue(this.postalCodeInput, this.address.postal_code)
    this.statusInput.value = this.address.street ? 'Validated' : 'Zip Only'
  }

  copyValue(input, value) {
    if (value) {
      input.value = value
      input.parentElement.classList.add('is-dirty')
    }
  }
}
